import { ActionEnum } from "../action.enum";
import { CompanyContactDtoModel } from '../../models/company-contact/company-contact-dto.model';

export namespace CompanyContactDialogAction {

  export class Create {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_DIALOG_CREATE;
  }

  export class Edit {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_DIALOG_EDIT;

    constructor(public companyContactId: number) {}
  }

  export class UpdateState {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_DIALOG_UPDATE_STATE;

    constructor(public companyContact: CompanyContactDtoModel) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_DIALOG_SAVE;
  }

  export class Delete {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_DIALOG_DELETE;
  }

  export class Close {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_DIALOG_CLOSE;
  }

  export class Reset {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_DIALOG_RESET;
  }

}
